<template>
  <div>
    <main-image-section
      img="https://tuango-contest-assets.s3.amazonaws.com/homepage/estrie.jpg"
    />
    <div class="container">
      <div class="row">
        <div class="col text-center font-default">
          <div class="block p-t">
            <h2 class="fnt font-deco">
              {{ $t("SHARE_PAGE__TITLE") }}
            </h2>
            <p v-if="customMsg" v-html="customMsg"></p>
            <p v-html="$t('SHARE_PAGE__INTRO')"></p>
          </div>

          <div class="content-narrow">
            <div class="block p-t">
              <el-button
                v-if="supportShareAPI"
                type="info"
                @click="shareAPI"
                class="w100"
              >
                {{ $t("SHARE_PAGE__SHARE_CONTEST") }}
                <i class="fas fa-share"></i>
              </el-button>

              <social-sharing
                v-else
                :url="url"
                :title="$t('SHARED__APP_TITLE')"
                :description="$t('SHARED__APP_DESCRIPTION')"
                twitter-user="tuango"
                inline-template
              >
                <div>
                  <network network="facebook">
                    <a class="c-share-btn c-share-btn--fb" href="javascript:;"
                      ><i class="fab fa-facebook-f"></i
                      >{{ $t("SHARE_PAGE__FACEBOOK_BTN") }}</a
                    >
                  </network>
                  <network network="twitter">
                    <a class="c-share-btn c-share-btn--tw" href="javascript:;"
                      ><i class="fab fa-twitter"></i
                      >{{ $t("SHARE_PAGE__TWITTER_BTN") }}</a
                    >
                  </network>
                </div>
              </social-sharing>
            </div>
          </div>

          <div class="block">
            <h4 class="fnt font-deco" v-html="$t('SHARE_PAGE__MERCI')"></h4>
          </div>

          <div class="content-narrow">
            <div class="block p-b">
              <el-button @click="gotoTuango" type="primary" class="w100">
                {{ $t("SHARE_PAGE__VISIT_TUANGO_BTN") }}
              </el-button>
            </div>
            <!--            <div class="block p-b">
              <el-button
                @click="gotoAirTransat"
                type="primary"
                class="w100"
                style="background-color:#0469AC; border-color:#0469AC"
              >
                {{ $t("SHARED__VISIT_AIR_TRANSAT") }}
              </el-button>
            </div>
            <div class="block p-b">
              <el-button
                @click="gotoIDC"
                type="primary"
                class="w100"
                style="background-color:#0C0C0C; border-color:#0C0C0C"
              >
                {{ $t("SHARED__VISIT_IDC") }}
              </el-button>
            </div>-->
            <div class="block p-b">
              <el-button
                v-if="token"
                @click="gotoMyPlane"
                type="primary"
                class="w100"
              >
                {{ $t("SHARE_PAGE__MY_PLANE_BTN") }}
                <i class="fas fa-car-side"></i>
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex"
import SocialSharing from "vue-social-sharing"

import MainImageSection from "../components/Layout/MainImageSection"

const { mapGetters } = createNamespacedHelpers("app")

export default {
  name: "Share",
  components: {
    MainImageSection,
    SocialSharing
  },
  props: {
    customMsg: {
      type: String
    }
  },
  data() {
    return {
      token: null,
      userId: null
    }
  },
  computed: {
    ...mapGetters(["utmQs"]),
    url() {
      return (
        "https://" +
        process.env[`VUE_APP_DOMAIN_${this.$i18n.locale.toUpperCase()}`]
      )
    },
    shareData() {
      return {
        title: this.$t("SHARED__APP_TITLE"),
        text: this.$t("SHARED__APP_DESCRIPTION"),
        url: this.url
      }
    },
    supportShareAPI() {
      return !!navigator.share
    }
  },
  methods: {
    gotoMyPlane() {
      this.$router.push({
        name: "status",
        query: { t: this.token, u: this.userId }
      })
    },
    gotoTuango() {
      window.location.assign(
        `https://www.tuango.ca/${this.$i18n.locale}/category/escapades/?${this.utmQs}`
      )
    },
    gotoAirTransat() {
      const url =
        this.$i18n.locale === "fr"
          ? "https://www.airtransat.com/fr-CA/accueil"
          : "https://www.airtransat.com/en-CA/home"
      window.location.assign(url)
    },
    gotoIDC() {
      const url =
        this.$i18n.locale === "fr"
          ? "https://www.idcdermo.com/ca_fr/?utm_campaign=concours_solis&utm_medium=affiliate&utm_source=tuango&utm_content=idc_dermo"
          : "https://www.idcdermo.com/ca_en/?utm_campaign=concours_solis&utm_medium=affiliate&utm_source=tuango&utm_content=idc_dermo"
      window.location.assign(url)
    },
    async shareAPI() {
      try {
        await navigator.share(this.shareData)
      } catch (err) {
        console.error(err)
      }
    }
  },

  created() {
    this.token = this.$route.query.t
    this.userId = this.$route.query.u
  }
}
</script>

<style scoped></style>
